export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('contactForm', () => {
        const CATEGORY_IDS = {
          contact_form_presale: 'I have questions before placing an order',
          contact_form_order_issues: 'There is an issue with my existing order',
          contact_form_order_status:
            'I would like to know the status of my order',
          contact_form_cancel_request: 'I would like to cancel a service',
          contact_form_other: 'Other',
        };
        const getDataToSend = (payload) => {
          const category = payload.contact_reason;
          const body = payload.message;
          const name = payload.firstname;
          const email = payload.email;
          const phone = payload.phone;
          const orderNumber = payload.order_number;
          const subject =
            'Contact Form - ' +
            name +
            ' ' +
            phone +
            ' - ' +
            orderNumber +
            ' - ' +
            CATEGORY_IDS[category];

          return {
            request: {
              subject,
              comment: { body },
              34883690955931: CATEGORY_IDS[category],
              7872990452123: orderNumber ?? 'N/A',
              34883995277851: CATEGORY_IDS[category],
              tags: [category ?? 'contact_form_other'],
              requester: {
                name,
                email,
              },
            },
          };
        };

        return {
          inputs: {
            firstname: '',
            email: '',
            message: '',
            phone: '',
            terms_agree: false,
            order_number: '',
            contact_reason: '',
          },
          errors: {},
          showMessage: false,
          successMessage: null,
          errorMessage: null,
          CATEGORY_IDS,

          validateField(fieldName) {
            delete this.errors[fieldName];
            switch (fieldName) {
              case 'firstname':
                if (!this.inputs.firstname.trim()) {
                  this.errors.firstname =
                    'Please complete this required field.';
                } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.firstname)) {
                  this.errors.firstname =
                    'Must only contain letters, numbers, and spaces.';
                } else if (this.inputs.firstname.length > 50) {
                  this.errors.firstname = 'Must be less than 50 characters.';
                }
                break;

              case 'phone':
                if (!this.inputs.phone) return;
                try {
                  const parsed = parseInt(this.inputs.phone);
                  if (isNaN(parsed)) {
                    this.errors.phone = 'Must be a number.';
                  }
                } catch (e) {
                  this.errors.phone = 'Must be a number.';
                }
                break;

              case 'email':
                if (!this.inputs.email.trim()) {
                  this.errors.email = 'Please complete this required field.';
                } else if (!this.validateEmail(this.inputs.email)) {
                  this.errors.email = 'Email must be formatted correctly.';
                }
                break;

              case 'message':
                if (!this.inputs.message.trim()) {
                  this.errors.message = 'Please complete this required field.';
                }
                break;

              case 'terms_agree':
                if (!this.inputs.terms_agree) {
                  this.errors.terms_agree =
                    'Please complete this required field.';
                }
                break;

              case 'contact_reason':
                if (!this.inputs.contact_reason) {
                  this.errors.contact_reason =
                    'Please add this required field.';
                } else if (
                  !Object.keys(this.CATEGORY_IDS).includes(
                    this.inputs.contact_reason,
                  )
                ) {
                  this.errors.contact_reason =
                    'Please select a valid contact reason.';
                }
                break;

              default:
                break;
            }
          },

          validateAll() {
            this.errors = {};

            Object.keys(this.inputs).forEach((fieldName) => {
              this.validateField(fieldName);
            });
          },

          validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email.toLowerCase());
          },

          async submitForm() {
            this.validateAll();
            if (Object.keys(this.errors).length > 0) {
              return;
            }

            const payload = {
              firstname: this.inputs.firstname,
              email: this.inputs.email,
              message: this.inputs.message,
              phone: this.inputs.phone,
              order_number: this.inputs.order_number,
              contact_reason: this.inputs.contact_reason,
            };

            const data = getDataToSend(payload);

            const headers = {
              'Content-Type': 'application/json',
            };

            try {
              const response = await fetch(
                `https://${import.meta.env.VITE_ZENDESK_SUBDOMAIN}.zendesk.com/api/v2/requests.json`,
                {
                  method: 'POST',
                  headers,
                  body: JSON.stringify(data),
                  auth: {
                    username: `${import.meta.env.VITE_ZENDESK_USER_EMAIL}/token`,
                    password: import.meta.env.VITE_ZENDESK_API_TOKEN,
                  },
                },
              );

              if (response.ok) {
                this.showMessage = true;
                this.successMessage =
                  data?.data?.inlineMessage ||
                  'Thank you for submitting the form. One of our customer service agents will email you as soon as possible.';
                this.errorMessage = false;
                this.resetForm();
              } else {
                this.showMessage = true;
                this.successMessage = '';
                this.errorMessage =
                  '<strong>We couldn’t submit your form</strong><br />Please give it another try!';
              }
            } catch (error) {
              console.error('Error:', error);
              this.showMessage = true;
              this.successMessage = '';
              this.errorMessage =
                '<strong>We couldn’t submit your form</strong><br />Please give it another try!';
            }
          },

          resetForm() {
            this.inputs.firstname = '';
            this.inputs.email = '';
            this.inputs.phone = '';
            this.inputs.message = '';
            this.inputs.terms_agree = false;
            this.errors = {};
            const formWrapper = document.getElementById('form-wrapper');

            if (formWrapper) {
              formWrapper.scrollIntoView({ behavior: 'smooth' });
            }
          },

          changeContactReason(value) {
            this.inputs.contact_reason = value;
            this.validateField('contact_reason');
          },
        };
      });
    });
  },
};
